import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_points_collectionPointId = z.any()
export type TagsGetCollection_points_collectionPointId = z.infer<typeof tagsGetCollection_points_collectionPointId>

export const paramsGetCollection_points_collectionPointId = z.object({ "collectionPointId": z.string() })
export type ParamsGetCollection_points_collectionPointId = z.infer<typeof paramsGetCollection_points_collectionPointId>

export const responseGetCollection_points_collectionPointId = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "identifier": z.string(), "customType": z.string().optional(), "supplier": z.string(), "price": z.string(), "singleRateTariff": z.boolean().optional(), "buildingId": z.string(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "meterCodes": z.array(z.string()).optional(), "order": z.number().optional(), "consumptionReminderEnabled": z.boolean().optional(), "consumptionReminderStartDate": z.union([z.string().date(), z.null()]).optional(), "consumptionReminderFrequency": z.enum(["weekly","monthly","yearly"]).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetCollection_points_collectionPointId = z.infer<typeof responseGetCollection_points_collectionPointId>

interface IGetCollection_points_collectionPointId extends BaseMethodType {
  tags: TagsGetCollection_points_collectionPointId,
  params: ParamsGetCollection_points_collectionPointId,
  response: ResponseGetCollection_points_collectionPointId
}
export const tagsDeleteCollection_points_collectionPointId = z.any()
export type TagsDeleteCollection_points_collectionPointId = z.infer<typeof tagsDeleteCollection_points_collectionPointId>

export const paramsDeleteCollection_points_collectionPointId = z.object({ "collectionPointId": z.string() })
export type ParamsDeleteCollection_points_collectionPointId = z.infer<typeof paramsDeleteCollection_points_collectionPointId>

export const responseDeleteCollection_points_collectionPointId = z.any()
export type ResponseDeleteCollection_points_collectionPointId = z.infer<typeof responseDeleteCollection_points_collectionPointId>

interface IDeleteCollection_points_collectionPointId extends BaseMethodType {
  tags: TagsDeleteCollection_points_collectionPointId,
  params: ParamsDeleteCollection_points_collectionPointId,
  response: ResponseDeleteCollection_points_collectionPointId
}
export const URL = '/collection-points/:collectionPointId'
export const validation = {
  get: {
    tags: tagsGetCollection_points_collectionPointId,
    params: paramsGetCollection_points_collectionPointId,
    response: responseGetCollection_points_collectionPointId
  },
  delete: {
    tags: tagsDeleteCollection_points_collectionPointId,
    params: paramsDeleteCollection_points_collectionPointId,
    response: responseDeleteCollection_points_collectionPointId
  }
}
export interface Collection_points_collectionPointId extends BaseRouteType {
  get: IGetCollection_points_collectionPointId,
  delete: IDeleteCollection_points_collectionPointId
}